import { createFeatureSelector, createSelector } from '@ngrx/store';
import { permissionsFeatureKey, PermissionStates, PermState } from '../../permission-controller/root';
import { clientSidePermissionsAdapter } from '../states/client-side-permission.states';

const selectFeature = createFeatureSelector<PermState>(permissionsFeatureKey);

export const selectClientSidePermissionFeature = createSelector(
  selectFeature,
  (s1) => s1.clientSide
)

export const selectEntity = (state: PermissionStates) => state.permissions.clientSide.selectedEntity;
export const selectUpdatePermSetListing = (state: PermissionStates) => state.permissions.clientSide.requiresUpdate;

export const {
  selectAll,
  selectEntities,
  selectIds,
  selectTotal
} = clientSidePermissionsAdapter.getSelectors(selectClientSidePermissionFeature);
